var _a;
import { handleKeydown } from '../../../utils/form';
import { unmask } from '../../../utils/shared';
import { makeFormContext } from './Form';
import valid from 'card-validator';
var cardNumber = {
    props: {
        id: 'cardNumber',
        name: 'cardNumber',
        placeholder: '1234 1234 1234 1234',
        autoComplete: 'cc-number',
        autoCorrect: 'off',
        spellCheck: false,
        inputMode: 'numeric',
        onKeyDown: handleKeydown,
    },
    required: true,
    pattern: /^(\d+)?$/g,
    mask: function (value) {
        var unmasked = unmask(value);
        var numberValidation = valid.number(unmasked);
        var card = numberValidation.card;
        if (card) {
            var max = card.lengths.includes(16) ? 16 : card.lengths[0];
            var gaps_1 = card.gaps.concat(max);
            var newVal = gaps_1
                .map(function (gap, i) { return unmasked.slice(gaps_1[i - 1] || 0, gap); })
                .filter(function (v) { return v; })
                .join(' ');
            return newVal;
        }
        return value;
    },
    unmask: unmask,
    getCursorPosition: function (element) {
        var unmasked = unmask(element.value);
        var numberValidation = valid.number(unmasked);
        var card = numberValidation.card;
        var lengthChange = element.value.length - element.oldValue.length;
        var unmaskedChange = unmask(element.value).length - unmask(element.oldValue).length;
        if (card) {
            var gaps = card.gaps;
            var oldCursor = element.oldCursor;
            var oldSeparation = gaps.filter(function (gap, i) { return gap + i < element.oldCursor; }).length;
            var newSeparation = gaps.filter(function (gap, i) { return gap + i < element.oldCursor + lengthChange; }).length;
            var newCursor = oldCursor - oldSeparation + newSeparation + unmaskedChange;
            return newCursor;
        }
        return undefined;
    },
    blurError: function (value) {
        var unmasked = unmask(value);
        var numberValidation = valid.number(unmasked);
        if (!numberValidation.isValid) {
            return 'Card number is invalid';
        }
        return '';
    },
    changeError: function (value) {
        var unmasked = unmask(value);
        var numberValidation = valid.number(unmasked);
        if (!numberValidation.isPotentiallyValid) {
            return 'Card number is invalid';
        }
        return '';
    },
    fieldNames: ['paymentInstrument.pan'],
};
var cardExpiry = {
    props: {
        id: 'cardExpiry',
        name: 'cardExpiry',
        placeholder: 'MM / YY',
        autoComplete: 'cc-exp',
        autoCorrect: 'off',
        spellCheck: false,
        inputMode: 'numeric',
        onKeyDown: handleKeydown,
    },
    required: true,
    pattern: /^\d{0,4}$/g,
    blurError: function (value) {
        var unmasked = unmask(value);
        if (unmasked && unmasked.length !== 4) {
            return 'Your card expiration is incomplete.';
        }
        if (isExpired(unmasked)) {
            return "Your card's expiration year is in the past.";
        }
        return '';
    },
    changeError: function (value) {
        if (isExpired(unmask(value))) {
            return "Your card's expiration year is in the past.";
        }
        return '';
    },
    mask: function (value) {
        if (unmask(value).match(/^[2-9]/)) {
            return makeMask(' / ', 2)("0".concat(value));
        }
        return makeMask(' / ', 2)(value);
    },
    unmask: unmask,
    fieldNames: ['paymentInstrument.expMonth', 'paymentInstrument.expYear'],
};
var cardCvc = {
    props: {
        id: 'cardCvc',
        name: 'cardCvc',
        placeholder: 'CVC',
        autoComplete: 'cc-csc',
        autoCorrect: 'off',
        spellCheck: false,
        inputMode: 'numeric',
        onKeyDown: handleKeydown,
    },
    pattern: /^\d{0,4}$/g,
    required: true,
    blurError: function (value, form) {
        var num = getCardNumber(form);
        var max = getCardNumberCvcMax(num);
        var cvvValidation = valid.cvv(value, max);
        if (!cvvValidation.isValid) {
            return 'Your card cvc is invalid.';
        }
        return '';
    },
    changeError: function (value, form) {
        var num = getCardNumber(form);
        var max = getCardNumberCvcMax(num);
        var cvvValidation = valid.cvv(value, max);
        if (!cvvValidation.isPotentiallyValid) {
            return 'Your card cvc is invalid.';
        }
        return '';
    },
    fieldNames: ['paymentInstrument.cvv'],
};
export var cardValues = {
    cardNumber: cardNumber,
    cardExpiry: cardExpiry,
    cardCvc: cardCvc,
};
export var CardContext = (_a = makeFormContext({
    name: 'Card',
    formValues: cardValues,
}), _a.Context), CardProvider = _a.Provider, useCard = _a.useForm;
function makeMask(separator, limit) {
    return function (value) {
        var output = [];
        for (var i = 0; i < value.length; i++) {
            if (i !== 0 && i % limit === 0) {
                output.push(separator);
            }
            output.push(value[i]);
        }
        return output.join('');
    };
}
function isExpired(value) {
    if (value.length === 4) {
        var today = new Date();
        var century = Math.floor(today.getFullYear() / 100) * 100;
        var mm = Number(value.slice(0, 2));
        var yy = Number(value.slice(2));
        var yyyy = century + yy;
        var expiration = new Date();
        expiration.setFullYear(yyyy, mm + 1, 1);
        if (expiration < today) {
            return true;
        }
    }
    return false;
}
function getCardNumber(form) {
    var name = cardNumber.props.name;
    if (form && name && form[name]) {
        return form[name].value;
    }
    return '';
}
function getCardNumberCvcMax(num) {
    var numberValidation = valid.number(num);
    return numberValidation.card ? numberValidation.card.code.size : 3;
}
//# sourceMappingURL=Card.js.map